module.exports = "<button mat-button class=\"hero-btn\" type=\"button\" (click)=\"openRightMenu($event)\">\n  <ng-content></ng-content>\n</button>\n"